import {
  PENDING_TOOLTIP,
  VERIFIED_TOOLTIP,
  getDealerVerificationLabel,
  getDealerVerificationPublicState,
  shouldShowDealerPendingBadge,
  shouldShowDealerVerificationBadge,
} from "../../../utils/dealerVerificationDisplay";
import { getDealerInitials } from "../autoclaroSearchUtils";

export const VERIFICATION_TOOLTIP = VERIFIED_TOOLTIP;
export const TRUST_DISCLAIMER =
  "AutoMapa confirmó la información principal del concesionario, incluyendo contacto, ubicación y canal de atención. Recomendamos verificar documentos, historial del vehículo y condiciones antes de comprar.";

export function getVerificationBadge(verificationStatus, dealer = null) {
  const subject = dealer || { verificationStatus };
  const state = getDealerVerificationPublicState(subject);
  if (state.showBadge) {
    return {
      label: getDealerVerificationLabel(subject, "profile") || "Verificado por AutoMapa",
      className: "verified",
    };
  }
  if (state.showPending) {
    return { label: "Verificación en proceso", className: "pending" };
  }
  return null;
}

export function offersFinancingLabel(value) {
  if (value === "yes") return "Financiación disponible";
  if (value === "sometimes") return "Financiación disponible";
  return null;
}

export function formatResponseTime(minutes) {
  if (minutes == null || Number.isNaN(Number(minutes))) return null;
  const value = Number(minutes);
  if (value < 60) return `Responde en ${value} min`;
  const hours = Math.round(value / 60);
  return `Responde en ${hours} h`;
}

export function buildDealerInitials(dealer) {
  return getDealerInitials(dealer?.businessName);
}

export function buildDealerLocationLabel(dealer) {
  return [dealer?.neighborhood, dealer?.city].filter(Boolean).join(" · ") || dealer?.city || "Colombia";
}

export function buildDealerSeoTitle(dealer) {
  const city = dealer?.city || "Colombia";
  return `${dealer?.businessName} en AutoMapa | Carros usados en ${city}`;
}

export function buildDealerSeoDescription(dealer) {
  return `Consulta vehículos disponibles, contacto y datos de confianza de ${dealer?.businessName} en AutoMapa.`;
}

export function buildLocalBusinessSchema(dealer, profileUrl) {
  if (!dealer) return null;
  return {
    "@context": "https://schema.org",
    "@type": "AutoDealer",
    name: dealer.businessName,
    url: profileUrl,
    image: dealer.coverImageUrl || dealer.logoUrl || undefined,
    address: dealer.address
      ? {
          "@type": "PostalAddress",
          streetAddress: dealer.address,
          addressLocality: dealer.city,
          addressCountry: "CO",
        }
      : undefined,
    telephone: dealer.mainWhatsapp || undefined,
  };
}

export const INVENTORY_SORT_OPTIONS = [
  { value: "recommended", label: "Recomendados" },
  { value: "price_asc", label: "Precio menor" },
  { value: "price_desc", label: "Precio mayor" },
  { value: "newest", label: "Más recientes" },
  { value: "mileage_asc", label: "Menor kilometraje" },
];

export { shouldShowDealerVerificationBadge, shouldShowDealerPendingBadge, PENDING_TOOLTIP };
